module.exports = __webpack_public_path__ + "static/media/cn_logo_blanco.001d8465.svg";